"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBillingDetailChanges = void 0;
var tslib_1 = require("tslib");
var util_1 = require("../lib/util");
function useBillingDetailChanges(props) {
    var onChange = props.onChange, localSurplusLines = props.localSurplusLines, setLocalSurplusLines = props.setLocalSurplusLines;
    return {
        handleChange: function (billingDetails) {
            if (onChange) {
                onChange(billingDetails);
            }
        },
        calculateStateTax: function (premium, existingValue, stateInfo) {
            var _a;
            if (stateInfo) {
                return (0, util_1.roundNumber)(premium * ((_a = stateInfo.stateTax) !== null && _a !== void 0 ? _a : 0));
            }
            return existingValue;
        },
        calculateStateFee: function (premium, existingValue, stateInfo) {
            var _a;
            if (stateInfo) {
                return (0, util_1.roundNumber)(premium * ((_a = stateInfo.stateFee) !== null && _a !== void 0 ? _a : 0));
            }
            return existingValue;
        },
        addSurplusLine: function () {
            if (localSurplusLines.length) {
                setLocalSurplusLines((0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], localSurplusLines, true), [{ item: undefined, value: undefined }], false));
                return;
            }
            setLocalSurplusLines([{ item: undefined, value: undefined }]);
        },
        updateSurplusLine: function (surplusRow, idx, surplusLines) {
            if (surplusRow.item) {
                var surplusLineCopy = surplusLines ? (0, tslib_1.__spreadArray)([], surplusLines, true) : [];
                surplusLineCopy[idx] = surplusRow;
                setLocalSurplusLines(surplusLineCopy);
                return surplusLineCopy;
            }
            return surplusLines;
        },
        deleteSurplusLine: function (idx, surplusLines) {
            if (!surplusLines) {
                var updatedLocalSurplusLines = (0, tslib_1.__spreadArray)([], localSurplusLines, true);
                updatedLocalSurplusLines.splice(idx, 1);
                setLocalSurplusLines(updatedLocalSurplusLines);
                return surplusLines;
            }
            var updatedSurplusLinesArray = (0, tslib_1.__spreadArray)([], surplusLines, true);
            updatedSurplusLinesArray.splice(idx, 1);
            setLocalSurplusLines(updatedSurplusLinesArray);
            return updatedSurplusLinesArray;
        },
        calculateTotal: function (billingDetails) {
            var sum;
            if (billingDetails.surplusLines) {
                sum = billingDetails.surplusLines
                    .map(function (fee) { return fee.value; })
                    .reduce(function (partialSum, a) { return (partialSum !== null && partialSum !== void 0 ? partialSum : 0) + (a !== null && a !== void 0 ? a : 0); }, 0);
            }
            return (billingDetails.premium +
                billingDetails.stateTax +
                billingDetails.stateStampingFee +
                billingDetails.miscTaxesAndFees +
                billingDetails.carrierPolicyFee +
                billingDetails.newfrontFee +
                billingDetails.wholesaleFee +
                (sum !== null && sum !== void 0 ? sum : 0));
        },
    };
}
exports.useBillingDetailChanges = useBillingDetailChanges;
//# sourceMappingURL=use-billing-detail-changes.js.map